import { Component, OnInit } from '@angular/core';
import { TermsAndConditionsType } from '@fgb/core';

@Component({
  selector: 'fgb-terms-page',
  templateUrl: './terms-page.component.html',
  styleUrls: ['./terms-page.component.scss'],
})
export class TermsPageComponent implements OnInit {
  termsAndConditionsType = TermsAndConditionsType.General;
  constructor() {}

  ngOnInit() {}
}
